import { useState, createContext } from "react";
import { isRomanianPath } from "../utils/hashNavigation";

export const LanguageContext = createContext({
  romanianLanguage: false,
  setRomanianLanguage: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [romanianLanguage, setRomanianLanguage] = useState(() => isRomanianPath());

  const value = {
    romanianLanguage,
    setRomanianLanguage,
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
